import React, { Component } from 'react'
import { connect } from 'react-redux'
import { beautifyPrice } from 'utils/stuff'

import TextField from 'material-ui/TextField'


let select = (state) => state


export class InputMoney extends Component {
	constructor(props) {
		super(props);
			this.state = {
				value: (this.props.value)?this.props.value:'',

			}
		}
		componentDidMount(){
			if (this.props.value){

				this.setState({value: this.props.value.toString()})

			}
		}
		render() {
			return (
				<div style={{...this.props.style}}>
					<TextField
						fullWidth={true}
						defaultValue={this.state.value}
						disabled={(this.props.disabled)?this.props.disabled:false}
						ref={(this.props.ref)?this.props.ref:''}
						onChange={(evt) => {
							let carret = evt.currentTarget.selectionStart
							let newVal = beautifyPrice(evt.target.value)
							if(this.state.value && evt.target.value.replace(/\D/g, '').length >= this.state.value.replace(/\D/g, '').length){
								if(newVal.length - evt.target.value.length == 1) carret = carret + 1
							}
							this.setState({value: newVal})
						}}
						style={{height:"50px"}}
						key={(this.props.key)?this.props.key:''}
						floatingLabelText={(this.props.floatingLabelText)?this.props.floatingLabelText:''}
						inputStyle={(this.props.inputStyle)?this.props.inputStyle:{fontSize: "14", color:"#000000"}}
						hintStyle={(this.props.hintStyle)?this.props.hintStyle:{fontStyle: "italic", fontSize: "14px"}}
						onBlur={(evt) => this.props.onBlur(evt.target.value)}
					/>
				</div>
			)
		}
}

export default connect(select)(InputMoney)



// WEBPACK FOOTER //
// ./src/components/InputLongInt.js